import toast from 'react-hot-toast'
import React, { useCallback, useEffect, useState } from 'react'

//interfaces
import { Message } from 'feature/chatbot/interface/chatbot'

//service configuration
import { API_CONFIG } from 'shared/constants/constant'
import httpService, { axiosInstance } from 'shared/services/http.service'

// shared component
import { ChatIcon } from 'shared/icon/icon'
import Demo from 'feature/chatbot/container/demo'

const ChatDemo = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [token, setToken] = useState({ token: '', expiry: '', url: '' });
    const [messages, setMessages] = useState<Message[]>([{ role: 'assistant', text: 'Hallo, ich bin Gerd ein virtuelles Teammitglied bei GER Umweltschutz. Wie kann ich Ihnen helfen?' }]);
    const [typeLoading, setTypeLoading] = useState(false);
    const [messageText, setMessageText] = useState('');
    const [loading, setLoading] = useState(false);

    const getToken = useCallback(async () => {
        if (!token.token) {
            try {
                const data = await httpService.post(`${API_CONFIG.path.token}`);
                setToken(data)

                return token;

            } catch (error) {
                toast.error('Failed to fetch token.');
                console.error('Token fetch error:', error);
            }
        }

        return token;
    }, [token]);

    const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!messageText.trim()) return;
        const newUserMessage: Message = {
            role: 'user',
            text: messageText
        };

        setMessages(prevMessages => [...prevMessages, newUserMessage]);
        const payload = {
            queryInput: {
                text: {
                    text: messageText,
                    languageCode: "de"
                }
            }
        }
        setMessageText('');
        const fetchedToken = await getToken();

        if (!fetchedToken) return;
        try {
            setTypeLoading(true)
            setLoading(true)
            const data = await axiosInstance.post(`https://dialogflow.googleapis.com/v2/${token.url}:detectIntent?access_token=${token.token}`, payload);
            const botMessage: Message = {
                role: 'assistant',
                text: data.data.queryResult?.fulfillmentText
            }
            setMessages(prevMessages => [...prevMessages, botMessage]);
            setLoading(false)
            setTypeLoading(false)
        } catch (error) {
            toast.error('Failed to communicate right now.');
            setTypeLoading(false)
            setLoading(false)
        }
    }, [getToken, messageText, token]);

    useEffect(() => {
        getToken();
    }, [getToken]);
    return (
        <div className='bot-wrapper h-screen'>
            {!isOpen && <div onClick={() => setIsOpen(!isOpen)} className="w-[65px] h-[65px] flex items-center justify-center fixed bottom-[32px] right-[32px] bg-[#0B6B20] cursor-pointer rounded-full">
                <ChatIcon className='w-[26px] h-[26px]' />
            </div>
            }
            {isOpen && (
                <div className='content-container'>
                    <Demo
                        onClose={() => setIsOpen(false)}
                        handleSubmit={handleSubmit}
                        messages={messages}
                        typeLoading={typeLoading}
                        loading={loading}
                        messageText={messageText}
                        setMessageText={setMessageText}
                    />
                </div>
            )}
        </div>
    )
}

export default ChatDemo